import DocusaurusFooter from '../DocusaurusFooter'
import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'
import {
  LinkToMonitorConfigs,
  LinkToTestConfigs,
  useModule
} from '@eggplant/routing'
import {
  monitorRunner,
  runner
} from '../../docs-routes'

const Runner = () => {
  const [isMonitorFlag] = useModule()

  const docsPath = !isMonitorFlag
    ? runner
    : monitorRunner

  const runnerTypeTitle = !isMonitorFlag
    ? 'Runner'
    : 'Monitor Runner'

  const linkToConfigs = !isMonitorFlag
    ? <LinkToTestConfigs>Test Config</LinkToTestConfigs>
    : <LinkToMonitorConfigs>Monitor Config</LinkToMonitorConfigs>

  return (
    <Paragraph>
      <Color
        display='inline'
        variant='theme-description-text'
      >
        Use the {runnerTypeTitle} to run and schedule test executions, and then view results from those test executions.
        <br />
        <br />
        Before you can use the {runnerTypeTitle}, you must have at least one {linkToConfigs}.
      </Color>
      <DocusaurusFooter path={docsPath} />
    </Paragraph>
  )
}

export default Runner
